import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const BriefcaseIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}

            <g clipPath="url(#clip0_138_4721)">
                <path
                    d="M8.70833 1.83333H8.20417C8.09779 1.31606 7.81633 0.851284 7.40724 0.517329C6.99815 0.183375 6.48643 0.000666657 5.95833 0L5.04167 0C4.51357 0.000666657 4.00185 0.183375 3.59276 0.517329C3.18367 0.851284 2.90221 1.31606 2.79583 1.83333H2.29167C1.6841 1.83406 1.10163 2.07574 0.672017 2.50535C0.242404 2.93496 0.000727768 3.51744 0 4.125L0 5.5H11V4.125C10.9993 3.51744 10.7576 2.93496 10.328 2.50535C9.89837 2.07574 9.3159 1.83406 8.70833 1.83333ZM3.751 1.83333C3.84545 1.56617 4.02015 1.33471 4.25118 1.17062C4.48221 1.00654 4.7583 0.917841 5.04167 0.916667H5.95833C6.2417 0.917841 6.51779 1.00654 6.74882 1.17062C6.97985 1.33471 7.15455 1.56617 7.249 1.83333H3.751Z"
                    fill={"currentColor"}
                />
                <path
                    d="M5.95833 6.87508C5.95833 6.99664 5.91004 7.11322 5.82409 7.19917C5.73814 7.28513 5.62156 7.33341 5.5 7.33341C5.37844 7.33341 5.26186 7.28513 5.17591 7.19917C5.08996 7.11322 5.04167 6.99664 5.04167 6.87508V6.41675H0V8.70841C0.000727768 9.31598 0.242404 9.89845 0.672017 10.3281C1.10163 10.7577 1.6841 10.9994 2.29167 11.0001H8.70833C9.3159 10.9994 9.89837 10.7577 10.328 10.3281C10.7576 9.89845 10.9993 9.31598 11 8.70841V6.41675H5.95833V6.87508Z"
                    fill={"currentColor"}
                />
            </g>
            <defs>
                <clipPath id="clip0_138_4721">
                    <rect width="11" height="11" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default BriefcaseIcon;
